import { PromptVersionView } from 'features/projects';

const PromptVersionPage = (): JSX.Element => <PromptVersionView />;

export default PromptVersionPage;
